import React from 'react';
import Dropzone from 'react-dropzone';
import AddButton from './AddDocumentButton';
import { toast } from 'react-toastify';
import { Card, Button, withStyles, Icon, CardContent, Typography, Chip } from '@material-ui/core';
import Download from '@material-ui/icons/CloudDownload';
import DocumentTags from '../common/DocumentTags';
import classNames from 'classnames';
import { removeTag } from '../../firebase/db'
import { downloadDoc } from '../../firebase/functions';
import saveAs from 'file-saver';

import _ from 'lodash'
const styles = theme => ({
    documents: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    documentCardContainer: {
        margin: 40,
        position: 'relative',
    },
    card: {
        margin: 15,
        width: 150,
        height: 150,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        alignContent: 'flex-start'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    deleteButton: {
        position: 'absolute',
        bottom: -20,
        left: -5,
        width: 40,
        height: 40,
        zIndex: 1001
    },
    addTags: {
        position: 'absolute',
        bottom: -20,
        right: -5,
        width: 40,
        height: 40,
        zIndex: 1001
    },
    extension: {
        margin: 30
    },
    textName: {
        fontSize: 12,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        width: 130,
        textAlign: 'left',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
    },
    documentsList: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center'
    },
    documentsListItem: {
        margin: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: 1000,
        borderBottom: '2px solid black'
    },
    iconText: {
        display: 'flex',
        flexDirection: 'column'
    }
});


class DropZone extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            popup: false,
            index: null,
            documents: {}
        }
    }

    componentDidMount() {
        if (this.props.documents) {
            this.setState({
                documents: this.props.documents
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.documents !== this.props.documents) {
            this.setState({ documents: this.props.documents })
        }
    }

    onChange = (accepted, rejected) => {
        const { handleAddDocument } = this.props;
        if (rejected.length > 0) {
            toast.error("Unsuported file type or file too large!", {
                position: "top-center",
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
            });
        } else if (accepted.length) {
            handleAddDocument(accepted);
        }
    }

    showDescription = (key) => {
        const { documents } = this.props
        if (documents[key].hasOwnProperty('tags') === false) {
            documents[key]['tags'] = []
        }
        this.setState({ popup: !this.state.popup, index: key })
        this.props.onTagsOpen(!this.state.popup);
    }

    handleTextFieldChange = (index, field, value) => {
        if (Array.isArray(this.state.documents[index]['tags'])) {
            let diff = _.difference(this.state.documents[index]['tags'], value);
            diff.map((tag) => {
                removeTag(this.state.index, tag);
            })
        } else {
            let diff2 = _.difference(Object.keys(this.state.documents[index]['tags']), value);
            diff2.map((tag) => {
                removeTag(this.state.index, tag);
            })
        }
        this.setState((state) => {
            const property = state.documents;
            if (typeof index !== 'undefined') {
                property[index][field] = value;
            } else {
                property[field] = value;
            }
            return { ...state, property };
        });
    };


    onCloseDescription = () => {
        const { onTagsChange, documents } = this.props;
        if (Array.isArray(documents[this.state.index].tags)) {
            documents[this.state.index].tags.forEach((tag) => {
                onTagsChange(this.state.index, tag);
            })
        } else {
            Object.keys(documents[this.state.index].tags).map((key) => {
                return onTagsChange(this.state.index, key)
            })
        }

        this.setState({ popup: false })
        this.props.onTagsOpen(false);
    }

    onCancelDialog = () => {
        this.setState({ popup: false });
        this.props.onTagsOpen(false);
    }

    downloadDocument = (filename, filePath) => {
        downloadDoc(filename, filePath)
            .then((response) => {
                saveAs(new Blob([response.data]), filename);
            })
            .catch((err) => {
                console.log(err);
            });
    }


    render() {
        let dropzoneRef;
        const { classes, documents, onDeleteDocument, onDescriptionChange } = this.props;
        // const documentsForRenderList = (
        //     <div className={classes.documentsList}>
        //         {
        //             Object.keys(documents).map((key, ind) => {
        //                 if (!documents[key].name) return null;
        //                 return (
        //                     <div className={classes.documentsListItem}>
        //                         <Typography variant="subheading" style={{ width: 100 }}>{(new Date(documents[key].uploadDate)).toLocaleDateString('de-AT')}</Typography>
        //                         <div style={{ width: 400 }}>
        //                             {
        //                                 Object.keys(documents[key].tags || {}).map(tag => <Chip
        //                                     label={tag}
        //                                     onDelete={(e) => console.log(e)} />)
        //                             }
        //                         </div>
        //                         <Typography variant="subheading" style={{ width: 200, marginLeft: 10 }}>{documents[key].name}</Typography>
        //                         <Typography variant="subheading" style={{ width: 200, marginLeft: 10 }}>{documents[key].description}</Typography>
        //                     </div>
        //                 )
        //             })
        //         }
        //     </div>
        // )


        const documentsForRender = Object.keys(documents || {}).sort((docId1, docId2) => documents[docId2].uploadDate - documents[docId1].uploadDate).map((key, ind) => {
            if (!documents[key].name) return null;
            let iconName = 'file';
            switch (documents[key].name.split('.').pop().toLowerCase()) {
                case 'jpg': case 'jpeg': case 'bpm': case 'tiff': case 'gif': case 'png': case 'svg':
                    iconName = 'file-image';
                    break;
                case 'pdf':
                    iconName = 'file-pdf';
                    break;
                case 'zip':
                    iconName = 'file-archive';
                    break;
                case 'doc': case 'docx': case 'odt':
                    iconName = 'file-word';
                    break;
                case 'xls': case 'xlsx': case 'csv':
                    iconName = 'file-excel';
                    break;
            }
            return (
                <div className={classes.documents}>
                    <div key={ind} className={classes.documentCardContainer}>
                        <Card className={classes.card}>
                            <CardContent>
                                <div className={classes.iconText}>
                                    <Icon
                                        className={classNames(classes.icon, `fa fa-${iconName}`)}
                                        color="primary"
                                        fontSize="large"
                                    />
                                    <div className={classes.textName} >
                                        {documents[key].name}
                                    </div>
                                    <div className={classes.textName} >
                                        {'Upload' + ': ' + (new Date(documents[key].uploadDate)).toLocaleDateString('de-AT')}
                                    </div>
                                </div>
                                <div style={{ backgroundColor: '#c5c2c2', height: '40px', width: '150px', display: 'flex', flexDirection: 'row', marginLeft: '-24px', marginTop: '30px', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ cursor: 'pointer', color: 'white', marginLeft: '10px' }}
                                        onClick={() => onDeleteDocument(key, documents[key].name)}
                                    >
                                        <img src={require('../../icons/trash.svg')} height="20" width="20" />
                                    </div>
                                    <div style={{ cursor: 'pointer' }}
                                        onClick={() => this.showDescription(key)}
                                    >
                                        <img src={require('../../icons/ribbon.svg')} height="20" width="20" />
                                    </div>
                                    <div style={{ cursor: 'pointer', marginRight: '10px' }}
                                        onClick={() => this.downloadDocument(documents[key].name, `documents/${key + '/' + documents[key].name}`)}
                                    >
                                        <Download />
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>

            )
        });


        return (
            <div>
                <Typography variant="title">Upload Dateien</Typography>
                <Dropzone
                    disableClick
                    accept={[
                        'image/tiff', 'image/jpeg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'application/pdf', 'text/csv', 'application/zip', 'audio/*', '.ppt', '.pptx']}
                    maxSize={10485760}
                    className="dropZone-doc"
                    activeClassName="dropZone-doc-act"
                    style={{}}
                    acceptClassName="dropZone-doc-acpt"
                    rejectClassName="dropZone-doc-rej"
                    disabledClassName="dropZone-doc-dis"
                    multiple={this.props.multiple}
                    ref={(node) => { dropzoneRef = node; }}
                    onDrop={(accepted, rejected) => this.onChange(accepted, rejected)}
                >
                    <AddButton title="Drop oder wähle vom Computer" onClick={() => { dropzoneRef.open() }}>
                    </AddButton>
                    {({ isDragActive, isDragReject }) => {
                        if (isDragActive && !isDragReject) {
                            return < div className="dropZoneDiv" >
                                <br />
                                <span>This file is authorized</span>
                            </div>;
                        }
                        if (isDragReject) {
                            return < div className="dropZoneDiv" >
                                <br />
                                <span>This file is not authorized</span>
                            </div>;
                        }
                    }}
                </Dropzone>
                <div className={classes.documents}>
                    {documentsForRender /* documentsForRenderList */}
                </div>
                {
                    this.state.popup &&
                    <DocumentTags
                        visible={this.state.popup}
                        tags={documents[this.state.index].tags}
                        description={documents[this.state.index].description}
                        onCancel={this.onCancelDialog}
                        onTagsChange={(tags) => this.handleTextFieldChange(this.state.index, 'tags', tags)}
                        onDescriptionChange={(e) => this.handleTextFieldChange(this.state.index, 'description', e.target.value)}
                        onDescriptionBlur={(e) => onDescriptionChange(this.state.index, e.target.value)}
                        onConfirm={this.onCloseDescription} />
                }
            </div >
        )
    }
}
export default withStyles(styles)(DropZone);


// WEBPACK FOOTER //
// ./src/components/common/DropZone.js